import styled from 'styled-components';
import { desktop1024 } from '@nubank/nuds-web/styles/breakpoints';
import Typography from '@nubank/nuds-web/components/Typography/Typography';

export const StyledTypography = styled(Typography)`
  ${desktop1024`
    width: 54rem;
  `}
`;

StyledTypography.displayName = 'StyledTypography';
